import { apiClient } from './apiClient';
import { Transfer, CreateTransferRequest, UpdateTransferRequest, GetTransfersFilters } from './types';

export const transferService = {
  async getAll(): Promise<Transfer[]> {
    return apiClient.get<Transfer[]>('/v1/transfers');
  },

  async getFiltered(filters: GetTransfersFilters): Promise<Transfer[]> {
    const params = new URLSearchParams();
    
    if (filters.dateFrom) {
      params.append('dateFrom', filters.dateFrom);
    }
    if (filters.dateTo) {
      params.append('dateTo', filters.dateTo);
    }
    if (filters.accountId) {
      params.append('accountId', filters.accountId);
    }
    if (filters.transferType) {
      params.append('transferType', filters.transferType);
    }
    
    const queryString = params.toString();
    const url = queryString ? `/v1/transfers?${queryString}` : '/v1/transfers';
    return apiClient.get<Transfer[]>(url);
  },

  async getByAccount(accountId: string): Promise<Transfer[]> {
    return apiClient.get<Transfer[]>(`/v1/transfers/account/${accountId}`);
  },

  async getById(id: string): Promise<Transfer> {
    return apiClient.get<Transfer>(`/v1/transfers/${id}`);
  },

  async create(transfer: CreateTransferRequest): Promise<Transfer> {
    return apiClient.post<CreateTransferRequest, Transfer>('/v1/transfers', transfer);
  },

  async update(id: string, transfer: UpdateTransferRequest): Promise<Transfer> {
    return apiClient.put<UpdateTransferRequest, Transfer>(`/v1/transfers/${id}`, transfer);
  },

  async delete(id: string): Promise<void> {
    await apiClient.delete(`/v1/transfers/${id}`);
  }
};



